// Pantalla de login del Dashboard JMA AFAC.
//
// Único punto de entrada a la aplicación cuando no hay sesión activa.
// El botón dispara MSAL.loginRedirect, que envía al usuario a
// login.microsoftonline.com con los scopes declarados en loginRequest.

import { html } from 'htm/preact'
import { login } from '../auth/auth-provider.js'

export function LoginScreen() {
  return html`
    <div class="auth-screen">
      <div class="auth-card">
        <img
          class="auth-card__logo"
          src="/logos/jma-cybersec-horizontal.png"
          alt="JMA CyberSec"
        />
        <h1 class="auth-card__title">Dashboard JMA AFAC</h1>
        <p class="auth-card__subtitle">
          Acceso restringido al personal autorizado de JMA CyberSec.
          Inicia sesión con tu cuenta corporativa Microsoft 365.
        </p>
        <button
          type="button"
          class="btn btn--primary auth-card__button"
          onClick=${() => login()}
        >
          Acceder con Microsoft
        </button>
        <p class="auth-card__legal">
          Al continuar se redirige a Microsoft para validar tu identidad.
          La aplicación solicita permisos para leer el perfil básico y
          gestionar la documentación AFAC en el SharePoint del tenant JMA.
        </p>
      </div>
    </div>
  `
}
